import { useState, useEffect } from "react";
import { Button, Box, Typography } from "@mui/material";
import { useNavigate, useLocation } from "react-router-dom";
import ProgressCom from "../../components/ProgressCom";
import Detail from "../../main/detail/Detail";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import { UseFAQ } from "./UseFAQ";
import Editor from "ckeditor5-custom-build/build/ckeditor";
import { rsProgress, rsActiveMenu } from "../../RecoilStates";
import { useRecoilState } from "recoil";
import useBreakpoints from "../../hooks/useBreakpoints";

function EditFAQRow(props) {
  const [msActiveMenu, setMsActiveMenu] = useRecoilState(rsActiveMenu);
  const [progress, setProgress] = useRecoilState(rsProgress);
  const navigate = useNavigate();
  const location = useLocation();
  const [brand, setBrand] = useState();
  const { updateFAQ } = UseFAQ();
  const [state, setState] = useState({
    productID: location.state.pID,
    faQs: [],
  });
  const [faqState, setFaqState] = useState({
    id: location.state.model.id,
    question: location.state.model.question,
    answer: location.state.model.answer,
    rowNO: location.state.model.rowNO,
  });
  const { isSmall } = useBreakpoints();

  useEffect(() => {
    if (faqState) {
      let temp = [];
      temp.push(faqState);
      setState({ ...state, faQs: temp });
    }
  }, [faqState]);

  return (
    <Detail
      breadChilds={{
        title: "محصولات",
        childs: [
          { name: msActiveMenu.pageTitle, url: "/faq" },
          {
            name: "ویرایش سوالات متداول",
            url: "/faq/editfaq",
            targetID: location.state.pID,
          },
          { name: "ویرایش سوال", url: "/faq/editfaq/editfaqrow" },
        ],
      }}
    >
      {!brand ? (
        <Box display="grid" gridTemplateColumns="repeat(12, 1fr)" gap={2}>
          <Box gridColumn={isSmall ? "span 12" : "span 6"}>
            {/* <TextField
              id="outlined-basic"
              size="small"
              value={faqState.question ? faqState.question : ""}
              label="سوال"
              variant="outlined"
              onChange={(event) => {
                setFaqState({ ...faqState, question: data });
              }}
              fullWidth
            /> */}
            <Typography sx={{ my: 1 }} variant="body1" color="secondary">
              سوال :
            </Typography>
            {state.id != "" && (
              <CKEditor
                config={{
                  language: "fa",
                  link: {
                    decorators: {
                      addTargetToExternalLinks: {
                        mode: "automatic",
                        callback: (url) => /^(https?:)?\/\//.test(url),
                        attributes: {
                          target: "_blank",
                          rel: "noopener noreferrer",
                        },
                      },
                    },
                  },
                }}
                editor={Editor}
                style={{ p: "100px", width: "100%" }}
                data={faqState.question ? faqState.question : ""}
                onChange={(event, editor) => {
                  const data = editor.getData();
                  if (faqState.id) {
                    setFaqState({ ...faqState, question: data });
                  }
                }}
                onReady={(editor) => {
                  editor.editing.view.change((writer) => {
                    writer.setStyle(
                      "height",
                      "300px",
                      editor.editing.view.document.getRoot()
                    );
                  });
                }}
              />
            )}
          </Box>
          <Box gridColumn={isSmall ? "span 12" : "span 6"}>
            <Typography sx={{ my: 1 }} variant="body1" color="secondary">
              پاسخ :
            </Typography>
            {state.id != "" && (
              <CKEditor
                config={{
                  language: "fa",
                  link: {
                    decorators: {
                      addTargetToExternalLinks: {
                        mode: "automatic",
                        callback: (url) => /^(https?:)?\/\//.test(url),
                        attributes: {
                          target: "_blank",
                          rel: "noopener noreferrer",
                        },
                      },
                    },
                  },
                }}
                editor={Editor}
                style={{ p: "100px", width: "100%" }}
                data={faqState.answer ? faqState.answer : ""}
                onChange={(event, editor) => {
                  const data = editor.getData();
                  if (faqState.id) {
                    setFaqState({ ...faqState, answer: data });
                  }
                }}
                onReady={(editor) => {
                  editor.editing.view.change((writer) => {
                    writer.setStyle(
                      "height",
                      "300px",
                      editor.editing.view.document.getRoot()
                    );
                  });
                }}
              />
            )}
          </Box>
          <Box
            gridColumn="span 12"
            sx={{ display: "flex", justifyContent: "center" }}
          >
            <Button
              sx={{ mr: 2, width: "100px" }}
              variant="contained"
              color="secondary"
              onClick={() => {
                updateFAQ(state, () => {
                  setProgress(true);
                  navigate("/faq/editfaq", {
                    state: {
                      id: location.state.pID,
                    },
                    replace: true,
                  });
                });
              }}
            >
              ثبت
            </Button>

            <Button
              sx={{ width: "100px" }}
              variant="outlined"
              color="secondary"
              onClick={() => {
                navigate("/faq/editfaq", {
                  state: {
                    id: location.state.pID,
                  },
                  replace: true,
                });
              }}
            >
              بازگشت
            </Button>
          </Box>
        </Box>
      ) : (
        <ProgressCom></ProgressCom>
      )}
    </Detail>
  );
}

export default EditFAQRow;
